import { useTranslation } from "react-i18next";
import { TbPlus, TbX } from "react-icons/tb";
import "./reviewTabScene.scss";

/** What happens on screen when the desktop app imports a patient: a new tab opens in the default browser
 *  with the review page (agent/src/uiPages.ts reviewPage). The tab title, heading and button labels are the
 *  app's own German wording, quoted verbatim so staff recognise the page. Decorative drawing; the caption
 *  carries the facts. */
export function ReviewTabScene() {
    const { t } = useTranslation();

    return (
        <figure className="review-tab">
            <div className="review-tab__window" aria-hidden="true">
                <div className="review-tab__strip">
                    <span className="review-tab__tab">
                        <img src="/favicon.svg" alt="" />
                        <span>{t("syncGuide.reviewTab.otherTab")}</span>
                    </span>
                    <span className="review-tab__tab review-tab__tab--active">
                        <img src="/media/sync/agent-icon.png" alt="" />
                        <span>Medinvoice — Importierter Patient</span>
                        <TbX />
                    </span>
                    <span className="review-tab__new">{t("syncGuide.reviewTab.newBadge")}</span>
                    <TbPlus className="review-tab__plus" />
                </div>
                <div className="review-tab__address">localhost</div>
                <div className="review-tab__page">
                    <span className="review-tab__heading">Neuer Patient aus der Praxissoftware</span>
                    <span className="review-tab__facts">
                        <span className="review-tab__fact"><b>Name</b><i /></span>
                        <span className="review-tab__fact"><b>Geboren</b><i className="review-tab__fact-short" /></span>
                        <span className="review-tab__fact"><b>E-Mail</b><i /></span>
                    </span>
                    <span className="review-tab__actions">
                        <span className="review-tab__btn review-tab__btn--danger">Import abbrechen</span>
                        <span className="review-tab__btn review-tab__btn--soft">Hinzufügen und Einwilligung senden</span>
                        <span className="review-tab__btn review-tab__btn--primary">Hinzufügen</span>
                    </span>
                </div>
            </div>
            <figcaption className="review-tab__caption">{t("syncGuide.reviewTab.caption")}</figcaption>
        </figure>
    );
}
